import $ from 'jquery'
import Swiper, { Autoplay, EffectFade, Navigation, Pagination } from 'swiper'
import 'swiper/swiper-bundle.css'
import store from '../../store'
import { qs, qsa } from '../../utils'
import DefaultRenderer from './Default'
Swiper.use([Navigation, Pagination, EffectFade, Autoplay])

class TermsRenderer extends DefaultRenderer {
  constructor(opts) {
    super(opts)
  }

  initRender() {
    // store.resizeFn = this.onResize.bind(this);
    store.resizeFn = null
    store.section = 'terms'

    this.setHeaderStyle('white')
    this.onPageChange()

    var objThis = this

    qsa('.term-type.term').forEach((element) => {
      element.addEventListener('click', function (ev) {
        const isActive = this.classList.contains('active')
        qsa('.term-type.term').forEach((element) => {
          element.classList.remove('active')
          element.removeAttribute('aria-current')
          if (this.id === 'term-multi') {
            element.setAttribute('aria-expanded', 'false')
          }
        })
        if (this.id === 'term-multi') {
          if (!isActive) {
            $('.term-type-hide').slideDown()
          } else {
            $('.term-type-hide').slideUp()
          }
        } else {
          $('.term-type-hide').slideUp()
        }

        if (this.dataset.termtrigger) {
          $('.terms-d-container').slideUp(650)
          $('#' + this.dataset.termtrigger).slideDown(650, () => {
            objThis.scroll.update()
          })
        }

        if (this.classList.contains('t-t-unstyle')) {
          qs('.term-type[data-termtrigger="t-2"]').classList.add('active')
          setTimeout(() => {
            $([document.documentElement, document.body]).animate(
              {
                scrollTop: $('body').offset().top,
              },
              500,
            )
          })
        } else {
          if (!isActive) {
            this.classList.toggle('active')
            this.setAttribute('aria-current', 'true')
            if (this.id === 'term-multi') {
              element.setAttribute('aria-expanded', 'true')
            }
          }
        }
      })
    })

    const termMulti = document.querySelector('#term-multi')
    if (termMulti) {
      termMulti.addEventListener('keydown', function (e) {
        const keyD = e.key !== undefined ? e.key : e.keyCode
        // e.key && e.keycode have mixed support - keycode is deprecated but support is greater than e.key
        // I tested within IE11, Firefox, Chrome, Edge (latest) & all had good support for e.key

        if (
          keyD === 'Enter' ||
          keyD === 13 ||
          ['Spacebar', ' '].indexOf(keyD) >= 0 ||
          keyD === 32
        ) {
          // In IE11 and lower, e.key will equal "Spacebar" instead of ' '

          // Default behavior is prevented to prevent the page to scroll when "space" is pressed
          e.preventDefault()
          e.target.click()
        }
      })
    }

    qsa('.term-type-hide > button').forEach((element) => {
      element.addEventListener('click', function (ev) {
        ev.stopPropagation()
        $('.terms-d-container').slideUp(650)
        $(`#${this.dataset.termtrigger}`).slideDown(650, () => {
          objThis.scroll.update()
        })

        qsa('.term-t-h-id').forEach((element) => {
          element.classList.remove('active')
        })

        this.classList.add('active')
        $(
          `#${this.dataset.termtrigger} .list-of-links > li a, #${this.dataset.termtrigger} a[href^="#"]`,
        ).each((ind, el) => {
          $(el).click(function (x) {
            const destName = this.hash.replace('#', '')
            let dest = $('.terms-d-block:visible').find(`[name="${destName}"][class="anchor"]`)[0]
            if (dest) {
              dest.scrollIntoView()
            } else {
              $('.terms-d-block:visible')
                .find(`[name="${destName}"][class="${destName}"]`)[0]
                .scrollIntoView()
            }
          })
        })
      })
    })

    qsa('.faq-row').forEach((element) => {
      element.addEventListener('click', function () {
        if (!this.classList.contains('active')) {
          $('.faq-row').removeClass('active')
          $('.faq-row').attr('aria-expanded', 'false')
          $('.faq-row p').slideUp()
          this.classList.add('active')
          $(this).attr('aria-expanded', 'true')
          // $(this+' p').slideToggle();
          $(this)
            .find('p')
            .slideToggle(400, () => {
              objThis.scroll.update()
              objThis.scrollTo({ target: element, offset: -200 })
            })
        } else {
          $(this).attr('aria-expanded', 'false')
          this.classList.remove('active')
          $(this)
            .find('p')
            .slideUp(400, () => {
              objThis.scroll.update()
              objThis.scrollTo({ target: element, offset: -200 })
            })
        }
      })
    })
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)

    // if (queryString) {
    //     let term = urlParams.get('term') || 1;
    //     term = term > 0 && term < 8 ? term : 1;
    //     qs('.term-t-h-id[data-termtrigger="t-' + term + '"]').classList.add('active');
    //     qsa('.terms-d-container').forEach((elem) => {
    //         $(elem).hide();
    //     });
    //     $('#t-' + term).show();
    // } else {
    //     qs('.term-t-h-id[data-termtrigger="t-1"]').classList.add('active');
    // }

    const tabName = window.location.hash.slice(1)
    if (tabName === 'privacy') {
      qs('.js-m-priv') && qs('.js-m-priv').classList.add('active')
    } else {
      qs('.js-m-trm') && qs('.js-m-trm').classList.add('active')
    }

    qsa('.js-priv').forEach((x) => {
      x.addEventListener('click', () => {
        qsa('.term-type.term').forEach((element) => {
          element.classList.remove('active')
        })

        setTimeout(() => {
          $([document.documentElement, document.body]).animate(
            {
              scrollTop: $('body').offset().top,
            },
            200,
          )

          qs('.js-m-priv').classList.toggle('active')

          $('.terms-d-container').slideUp(650)
          $('#t-2').slideDown(650, () => {
            objThis.scroll.update()
          })
        }, 100)

        if (store.isDevice) {
          qs('.js-as-selec').innerHTML = qs('.js-pv-name-mob').innerHTML
        }
      })
    })

    qsa('.js-term-svrs').forEach((x) => {
      x.addEventListener('click', () => {
        qsa('.term-type.term').forEach((element) => {
          element.classList.remove('active')
          element.setAttribute('aria-hidden', 'true')
        })

        setTimeout(() => {
          $([document.documentElement, document.body]).animate(
            {
              scrollTop: $('body').offset().top,
            },
            200,
          )

          qs('.js-m-trm').classList.toggle('active')
          qs('.js-m-trm').setAttribute('aria-hidden', 'true')

          $('.terms-d-container').slideUp(650)
          $('#t-1').slideDown(650, () => {
            objThis.scroll.update()
          })
        }, 100)

        if (store.isDevice) {
          qs('.js-as-selec').innerHTML = qs('.js-ts-name-mob').innerHTML
        }
      })
    })

    if (qs('.t-t-unstyle.term-type.term.js-m-priv'))
      qs('.t-t-unstyle.term-type.term.js-m-priv').addEventListener('click', () => {
        var outSelect = qs('.t-t-unstyle.term-type.term.js-m-priv')
        this.setCustomSelect(outSelect)
      })

    qsa('.goto-priv').forEach((e) => {
      e.addEventListener('click', () => {
        store.termsGoTo = e
      })
    })

    if (store.termsGoTo != null) {
      $('.terms-d-container').slideUp(650)

      $('#' + store.termsGoTo.dataset.termtrigger).slideDown(650, () => {
        objThis.scroll.update()
      })

      qsa('.term-t-h-id').forEach((element) => {
        element.classList.remove('active')
      })
      qs(
        '.term-t-h-id[data-termtrigger="' + store.termsGoTo.dataset.termtrigger + '"]',
      ).classList.add('active')
      if (store.termsGoTo.dataset.anchor != null) {
        setTimeout(() => {
          $([document.documentElement, document.body]).animate(
            {
              scrollTop: $(`.${store.termsGoTo.dataset.anchor}`).offset().top - 110,
            },
            700,
          )
          store.termsGoTo = null
        }, 800)
      } else {
        store.termsGoTo = null
      }
    }

    let auxActive = qs('.term-type.term.active')
    if (auxActive) {
      qs(`#${auxActive.dataset.termtrigger}`).style.display = 'block'
    }

    this.scrollToSection()
  }

  // changeTerms(id) {
  //     $('.terms-d-container').slideUp(650);
  //     $('#t-'+id).slideDown(650);
  // }

  scrollToSection() {
    qsa('.js-scrollElem').forEach((x) => {
      const elToScroll = x.dataset.anchor
      $(x).click(function () {
        $([document.documentElement, document.body]).animate(
          {
            scrollTop: $(`.${elToScroll}`).offset().top,
          },
          500,
        )
      })
    })
  }

  onEnter() {
    super.onEnter()
    qs('.downloadFooter').classList.add('d-none')
  }

  onLeave() {
    super.onLeave()
    qs('.downloadFooter').classList.remove('d-none')
  }

  onEnterCompleted() {
    super.onEnterCompleted()
    this.initRender()
  }

  onLeaveCompleted() {
    super.onLeaveCompleted()
  }
}

export default TermsRenderer
